import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import P from '../../elements/typography/p'
import SinglePostInner from '../../elements/singlePostInner'
import SectionTransition from '../../elements/activeSectionDefault'
import { breakpoint, getColor } from '../../shared/theme'

const ShareWrapper = styled(SectionTransition)`
	grid-column: -1 / 1;
	padding-bottom: 40px;

	@media ${breakpoint('tablet')} {
		padding-bottom: 180px;
	}
`

const Hr = styled.div`
	grid-column: -1 / 1;
	margin-bottom: 54px;
	max-width: 44px;
	height: 2px;
	background: ${getColor('black')};

	@media ${breakpoint('tablet')} {
		height: 4px;
		margin-bottom: 180px;
	}
`

const SocialShare = styled.div`
	display: inline-flex;
	align-items: center;
	grid-column: -1 / 1;
	justify-content: flex-start;
`

const Subheading = styled(P)`
	font-weight: 700;
	margin-right: 24px;
	display: none;

	@media ${breakpoint('tablet')} {
		display: inline-block;
	}
`

const ShareLink = styled.a`
	margin-right: 12px;
	height: 20px;
	display: inline-block;

	svg {
		height: 100%;
		display: block;
	}

	&:last-child {
		margin-right: 0;
	}
`
const Sharepost = ({ isActive, title, location }) => {
	const data = useStaticQuery(SHARE_URL_QUERY)
	const blogUri = '/more'
	const {
		wpgraphql: {
			generalSettings: { url: wordPressUrl },
		},
	} = data

	let siteUrl = wordPressUrl

	const createLocalLink = (uri) => {
		//Remove the trailing /wp from the WP url for Bedrock setups
		siteUrl = siteUrl.replace('/wp', '');

		//Remove the WP backend subdomain -- prod
		siteUrl = siteUrl.replace('admin.slyletica', 'slyletica'); //prod
		siteUrl = siteUrl.replace('slyletica.wp', 'slyletica'); //staging
		siteUrl = siteUrl.replace('slyletica-backend.tensq.com.au', 'slyletica.com'); // new server
		siteUrl = siteUrl.replace('cdn.slyletica', 'slyletica'); // new server

		//Change the new URL to a local one
		let newUri = siteUrl + location.pathname;

		return newUri
	}

	const cleanUrl = createLocalLink()

	return (
		<ShareWrapper isActive={isActive}>
			<SinglePostInner>
				<Hr />

				<SocialShare>
					<Subheading>Share:</Subheading>
					<ShareLink
						href={`https://twitter.com/intent/tweet?text=${title}&url=${cleanUrl}`}
						title={title}
						target="_blank"
					>
						<svg viewBox="0 0 35.4 28.8">
							<path
								d="M35.4,3.4c-1.3,0.6-2.7,1-4.2,1.1c1.5-0.9,2.7-2.3,3.2-4c-1.4,0.8-3,1.4-4.6,1.8C27.1-0.6,22.5-0.8,19.5,2
							c-1.9,1.8-2.7,4.4-2.1,6.9c-5.8-0.3-11.3-3-15-7.6C0.5,4.6,1.5,8.9,4.7,11c-1.2,0-2.3-0.3-3.3-0.9c0,0,0,0.1,0,0.1
							c0,3.5,2.4,6.4,5.8,7.1c-1.1,0.3-2.2,0.3-3.3,0.1c1,3,3.7,5,6.8,5c-3,2.4-6.9,3.5-10.7,3c3.3,2.1,7.2,3.3,11.1,3.3
							c13.4,0,20.7-11.1,20.7-20.7c0-0.3,0-0.6,0-0.9C33.2,6.1,34.4,4.9,35.4,3.4L35.4,3.4z"
							></path>
						</svg>
					</ShareLink>
					<ShareLink
						href={`https://www.facebook.com/sharer/sharer.php?u=${cleanUrl}`}
						target="_blank"
					>
						<svg viewBox="0 0 14.1 30.3">
							<path d="M13.5,15.2H9.3v15.1H3V15.2H0V9.8h3V6.3C3,3.9,4.2,0,9.3,0L14,0v5.2h-3.4 c-0.7,0-1.3,0.5-1.3,1.2c0,0.1,0,0.2,0,0.2v3.1h4.8L13.5,15.2z"></path>
						</svg>
					</ShareLink>
					<ShareLink
						href={`https://www.linkedin.com/sharing/share-offsite/?url=${cleanUrl}`}
						target="_blank"
					>
						<svg viewBox="0 0 260.366 260.366">
							<path d="M34.703,0.183C15.582,0.183,0.014,15.748,0,34.884C0,54.02,15.568,69.588,34.703,69.588 c19.128,0,34.688-15.568,34.688-34.704C69.391,15.75,53.83,0.183,34.703,0.183z" />
							<path d="M60.748,83.531H8.654c-2.478,0-4.488,2.009-4.488,4.489v167.675c0,2.479,2.01,4.488,4.488,4.488h52.093 c2.479,0,4.489-2.01,4.489-4.488V88.02C65.237,85.539,63.227,83.531,60.748,83.531z" />
							<path d="M193.924,81.557c-19.064,0-35.817,5.805-46.04,15.271V88.02c0-2.48-2.01-4.489-4.489-4.489H93.424 c-2.479,0-4.489,2.009-4.489,4.489v167.675c0,2.479,2.01,4.488,4.489,4.488h52.044c2.479,0,4.489-2.01,4.489-4.488v-82.957 c0-23.802,4.378-38.555,26.227-38.555c21.526,0.026,23.137,15.846,23.137,39.977v81.535c0,2.479,2.01,4.488,4.49,4.488h52.068 c2.478,0,4.488-2.01,4.488-4.488v-91.977C260.366,125.465,252.814,81.557,193.924,81.557z" />
						</svg>
					</ShareLink>
				</SocialShare>
			</SinglePostInner>
		</ShareWrapper>
	)
}

Sharepost.propTypes = {
	isActive: PropTypes.bool,
}

Sharepost.defaultProps = {
	isActive: true,
}

export default Sharepost

const SHARE_URL_QUERY = graphql`
	query GETSHAREWPURL {
		wpgraphql {
			generalSettings {
				url
			}
		}
	}
`
